import { SkapaTheme } from '@inter-ikea-kompis/themes/lib';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentView } from '../../state/navigation/navigationSelectors';
import { KompisMiniSurvey } from '@inter-ikea-kompis/react-components';
import { MiniSurveyStateEnum } from '@inter-ikea-kompis/component-mini-survey';
import { selectKompisTranslations } from '../../state/translations/translationsSelectors';
import { applicationSettings } from '../../settings/application';
import localStatisticsReporter from '../../services/statistics/insights/custom/local/localStatisticsReporter';
import { translate } from '../../services/L10n';
import { selectScreensaverIsActive } from '../../state/screensaver/screensaverSelectors';
import {
  selectSurveyState,
  selectSurveyVisible,
} from '../../state/popups/popupsSelectors';
import {
  actionSetSurveyState,
  actionSetSurveyVisible,
} from '../../state/popups/popupsActions';
import store from '../../state';
import { selectIsKiosk } from '../../state/userAgent/userAgentSelectors';
import { t } from '../../translations';

const Survey = () => {
  const isKiosk = useSelector(selectIsKiosk);
  const kompisTranslations = useSelector(selectKompisTranslations);
  const surveyVisible = useSelector(selectSurveyVisible);
  const surveyState = useSelector(selectSurveyState);
  const screensaverActive = useSelector(selectScreensaverIsActive);
  const currentView = selectCurrentView(store.getState());

  const APPLICATION_NAME = applicationSettings.applicationName;
  const WAIT_TIME_SUCCEED = applicationSettings.surveyWaitTimeSecondsOnSucceed;
  const WAIT_TIME = isKiosk
    ? applicationSettings.surveyWaitTimeSecondsKiosk
    : applicationSettings.surveyWaitTimeSeconds;
  const dispatch = useDispatch();

  const surveyDisplayed = () => {
    return localStorage.getItem('displayedSurveyFor' + APPLICATION_NAME);
  };

  const showSurvey = () => {
    //setTimeout restrict us from getting the latest state from screensaverActive, collect again..
    const screensaverActive = selectScreensaverIsActive(store.getState());
    if (!screensaverActive) {
      dispatch(actionSetSurveyVisible(true));
      localStatisticsReporter.reportShowSurvey();
      localStorage.setItem('displayedSurveyFor' + APPLICATION_NAME, 'true');
    }
  };

  const autoCloseSurvey = () => {
    //setTimeout restrict us from getting the latest state from surveyState, collect again..
    const surveyState = selectSurveyState(store.getState());
    if (surveyState === MiniSurveyStateEnum.success) {
      dispatch(actionSetSurveyState(MiniSurveyStateEnum.default));
      dispatch(actionSetSurveyVisible(false));
    }
  };

  useEffect(() => {
    surveyState === MiniSurveyStateEnum.success &&
      dispatch(actionSetSurveyVisible(false));
  }, [currentView]);

  useEffect(() => {
    if (!surveyDisplayed()) {
      setTimeout(() => {
        showSurvey();
      }, WAIT_TIME * 1000);
    }
  }, [screensaverActive]);

  const onSelect = (event: any) => {
    localStatisticsReporter.reportSurveyFeedback(
      event.detail.grade,
      currentView
    );
    dispatch(actionSetSurveyState(event.detail.state));

    setTimeout(() => {
      autoCloseSurvey();
    }, WAIT_TIME_SUCCEED * 1000);
  };

  const onClose = () => {
    localStatisticsReporter.reportTerminateSurvey();
    dispatch(actionSetSurveyVisible(false));
    dispatch(actionSetSurveyState(MiniSurveyStateEnum.default));
  };

  return (
    <KompisMiniSurvey
      theme={SkapaTheme}
      visible={surveyVisible}
      translations={kompisTranslations}
      questionText={translate(t.MINI_SURVEY_BODY)}
      top={10}
      left={10}
      zIndex={500}
      state={surveyState}
      onClose={onClose}
      onSelect={onSelect}
    />
  );
};

export default Survey;
